<template>
  <div class="q-px-xs">
    <q-layout view="hHh Lpr lff">
      <q-page-container :style="{ background: $q.dark.isActive ? '#121212' : '#eeeeee' }">
        <router-view></router-view>
      </q-page-container>
    </q-layout>
  </div>
</template>